import React from "react";

/**
 * Full-bleed map image with invisible hit targets.
 * Hotspots are percentages on top of the exact same map image element.
 */
export default function MapScreen({ background, hotspots, completed, onOpenStage }) {
  return (
    <div className="unhealthy-map-wrap" role="presentation">
      <img src={background} alt="" className="unhealthy-map-image" />
      {hotspots.map((spot) => {
        const done = Boolean(completed[spot.id]);
        return (
          <button
            key={spot.id}
            type="button"
            disabled={done}
            className={`unhealthy-hotspot ${done ? "is-done" : ""}`}
            style={{ top: spot.top, left: spot.left, width: spot.width, height: spot.height }}
            onClick={() => {
              if (done) return;
              onOpenStage(spot.id);
            }}
            aria-label={done ? `${spot.label} — completed` : spot.label}
          />
        );
      })}
    </div>
  );
}
